<template>
    <div>
        <div v-show="exibirInvestimentos">
            <app-tabela
                idTabela="tblInvestimentos"
                :itens="contrato.investimentosPrevistos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="valor" slot-scope="data">
                    {{ data.valor | currency }}
                </template>
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-inserir
                            :contrato="contrato"
                            @obterInvestimentosAtualizados="obterInvestimentos()"
                        ></btn-inserir>
                    </div>
                </template>
                <template slot="status" slot-scope="data">
                    <app-status
                        :status="data.status == 0 ? 'PENDENTE' : 'CONCLUÍDO'"
                    ></app-status>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar
                        :contrato="contrato"
                        :investimento="data"
                        :idInvestimentoPrevistoContrato="data.idInvestimentoPrevistoContrato"
                        @obterInvestimentosAtualizados="obterInvestimentos()"
                    ></btn-atualizar>
                    <btn-excluir
                        :contrato="contrato"
                        :investimento="data"
                        :idInvestimentoPrevistoContrato="data.idInvestimentoPrevistoContrato"
                        @obterInvestimentosAtualizados="obterInvestimentos()"
                    ></btn-excluir>
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-pie-chart fa-lg icon-button"
                            title="Detalhar Parcelamentos"
                            @click.stop="definirTela('parcelamentos', data)"
                        ></i>
                    </span>
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-paperclip fa-lg icon-button"
                            title="Detalhar Anexos"
                            @click.stop="definirTela('anexos',  data)"
                        ></i>
                    </span>
                </template>
            </app-tabela>
        </div>
        <div v-show="exibirParcelamentos">
            <parcelamentos
                :investimento="itemSelecionado ? itemSelecionado : {}"
                @voltarParaInvestimentos="definirTela('investimentos')"
                @obterInvestimentosAtualizados="obterInvestimentos()"
            >
            </parcelamentos>
        </div>
        <div v-show="exibirAnexos">
            <anexos
                :investimento="itemSelecionado ? itemSelecionado : {}"
                @voltarParaInvestimentos="definirTela('investimentos')"
                @obterInvestimentosAtualizados="obterInvestimentos()"
            >
            </anexos>
        </div>
    </div>
</template>

<script>
import InvestimentoServicos from './InvestimentoServicos'
import BtnInserir from './BtnInserirInvestimento'
import BtnAtualizar from './BtnAtualizarInvestimento'
import BtnExcluir from './BtnExcluirInvestimento'
import Parcelamentos from './parcelamentos/Parcelamentos'
import Anexos from './anexos/Anexos'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnExcluir,
        Parcelamentos,
        Anexos
    },
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            itensInvestimentos: [],
            itemSelecionado: '',
            telaAtiva: 'investimentos',
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor Total',
                    sortable: true
                },
                {
                    key: 'prazoFinal',
                    label: 'Prazo Final',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'observacao',
                    label: 'Observação',
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    _methods: {
        obterInvestimentos() {
            this.$store.dispatch('addRequest')
            InvestimentoServicos.obterInvestimentos(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarInvestimentos', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter os investimentos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        definirTela(novaTela, data = null) {
            this.telaAtiva = novaTela
            if (data) {
                this.itemSelecionado = data
            }

            if (novaTela == 'investimentos') {
                this.obterInvestimentos()
            }
        }
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
    created() {},

    computed: {
        exibirInvestimentos() {
            return this.telaAtiva === 'investimentos'
        },
        exibirParcelamentos() {
            return this.telaAtiva === 'parcelamentos'
        },
        exibirAnexos() {
            return this.telaAtiva === 'anexos'
        }
    },

    watch: {}
}
</script>
